import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import Toolbar from '@mui/material/Toolbar';
import * as XLSX from 'xlsx';
import { styles } from '../../style/style';
import { useSelector, useDispatch } from 'react-redux';
import log from '../../common/components/Logger'


export default function OrderSummaryDownloadTable(props) {


    const dispatch = useDispatch();
    const searchCriteria = useSelector((state) => state.searchFieldList.searchFieldData.payload);
    const rowData = [];
    const data = props.data.filter(row => row.modelList !== null)
    data.map(mainRow => {
        rowData.push({
            title: mainRow.allocGrpCd,ec1000: mainRow.ec1000,ec1300: mainRow.ec1300,
            ec2000: mainRow.ec2000,ec2500: mainRow.ec2500,ec3000: mainRow.ec2500,
            ec3100: mainRow.ec3100,ec3300: mainRow.ec3300,ec3400: mainRow.ec3400,
            ec3800: mainRow.ec3800,ec4000: mainRow.ec4000,ec4200: mainRow.ec4200,
            ec4300: mainRow.ec4300,ec4350: mainRow.ec4350,ec4800: mainRow.ec4800,
            ec4850: mainRow.ec4850,ec4B00: mainRow.ec4B00,ec4B01: mainRow.ec4B01,
            ec4D00: mainRow.ec4D00,ec4F00: mainRow.ec4F00,ec4P00: mainRow.ec4P00,
            ec5000: mainRow.ec5000,ec6000: mainRow.ec6000,total: mainRow.total
        })
        mainRow.modelList.map(subModel => {
            rowData.push({
                title: "   " + subModel.mdsngModlDesgntr,ec1000: subModel.ec1000,ec1300: subModel.ec1300,
                ec2000: subModel.ec2000,ec2500: subModel.ec2500,ec3000: subModel.ec2500,
                ec3100: subModel.ec3100,ec3300: subModel.ec3300,ec3400: subModel.ec3400,
                ec3800: subModel.ec3800,ec4000: subModel.ec4000,ec4200: subModel.ec4200,
                ec4300: subModel.ec4300,ec4350: subModel.ec4350,ec4800: subModel.ec4800,
                ec4850: subModel.ec4850,ec4B00: subModel.ec4B00,ec4B01: subModel.ec4B01,
                ec4D00: subModel.ec4D00,ec4F00: subModel.ec4F00,ec4P00: subModel.ec4P00,
                ec5000: subModel.ec5000,ec6000: subModel.ec6000,total: subModel.total
            })
        })
    })

    const exportToExcel = () => {

        const heading = [[
            'Model', 'EC1000', 'EC1300', 'EC2000', 'EC2500', 'EC3000',
            'EC3100', 'EC3300', 'EC3400', 'EC3800', 'EC4000', 'EC4200', 'EC4300',
            'EC4350', 'EC4800', 'EC4850', 'EC4B00', 'EC4B01', 'EC4D00', 'EC4F00',
            'EC4P00', 'EC5000', 'EC6000', 'Total']];

        const workbook = XLSX.utils.book_new();


        const worksheet = XLSX.utils.json_to_sheet(rowData, { origin: 'A9', skipHeader: true })
        XLSX.utils.sheet_add_json(worksheet, heading, {
            origin: 'A8', skipHeader: true
        });

        XLSX.utils.sheet_add_aoa(worksheet,[['Search Criteria: ']], {origin:'B2'})
        XLSX.utils.sheet_add_aoa(worksheet,[['Primary FAN: ',searchCriteria.primaryFan,'Charge-To BAC: ',searchCriteria.chargeToBac]], {origin:'C4'})
        XLSX.utils.sheet_add_aoa(worksheet,[['End User FAN: ',searchCriteria.endUserFan,'Charge-To BFC: ',searchCriteria.chargeToBfc]], {origin:'C5'})
        XLSX.utils.sheet_add_aoa(worksheet,[['Model Year: ',searchCriteria.modelYear.toString(),'Ship-To BAC: ',searchCriteria.shipToBac]], {origin:'C6'})

        XLSX.utils.book_append_sheet(workbook, worksheet, 'OrderRequestList');
        XLSX.writeFile(workbook, 'OrderRequestList.xlsx');

        log.info(`fos_ui_log: OrderSummaryDownloadTable():exportToExcel() => Successful Excel Download `)
        
    }

    return (
         <Toolbar sx={styles.orderSummaryToolbar}><IconButton id="exportButton" aria-label='Download to Excel' onClick={exportToExcel}><DownloadIcon /></IconButton></Toolbar>
    )
}
